'use strict';

var selectbox = require('./selectbox');

/**
 * Change State Field Type According to Country Selected
 * @param {string} elementSelector - the top level DOM selector element
 * @param {string} type - target type, default input
 * @param {string} country - selected country
 */
function transformSelectIntoInput(elementSelector, type, country) {
    var $el = $(elementSelector);

    $el.siblings('.select-selected', '.select-items').remove();

    if (!type || type === 'text') {
        $el.replaceWith($('<input />').attr({
            type: 'text',
            id: $el.attr('id'),
            name: $el.attr('name'),
            class: $el.attr('class'),
            value: ''
            }));
        $(elementSelector).removeClass('custom-select');
        $(elementSelector).parent().find('.custom-selectbox').addClass('d-none');
        $(elementSelector).removeClass('d-none');
    } else {
        $el.replaceWith($('<select />').attr({
            id: $el.attr('id'),
            name: $el.attr('name'),
            class: $el.attr('class'),
            value: $el.val()
            }));
        $el = $(elementSelector);
        $el.addClass('custom-select');
        $.each(window.stateCountries[country], function () {
            $el.append($('<option />').val(this.value).text(this.label ? this.label : 'Select State'));
        });

        $el.on('change', function () {
            $(this).find('option').removeAttr('selected');
            $(this).find('option[value="' + $(this).val() + '"]').attr('selected', '');
        });
        selectbox.destroy($el);
        selectbox.reInit($el);
    }
}

module.exports = {
    transformSelectIntoInput: transformSelectIntoInput
};
